import { Dataset } from '~/Api/Product/Dataset';

import { Action, ActionType } from './Action';

interface DatasetState {
	request: Promise<any>;
	isFetching: boolean;
	dataset: Dataset | null;
}

export interface State {
	byProductId: { [productId: string]: DatasetState };
}

function createState(): State {
	return {
		byProductId: {},
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionType.request:
			return {
				...state,
				byProductId: {
					...state.byProductId,
					[action.productId]: {
						request: action.request,
						isFetching: true,
						dataset: null,
					},
				},
			};

		case ActionType.receive:
			if (state.byProductId[action.productId]?.request !== action.request) {
				return state;
			}
			if (action.dataset === null) {
				const byProductId = { ...state.byProductId };
				delete byProductId[action.productId];
				return { ...state, byProductId };
			}

			return {
				...state,
				byProductId: {
					...state.byProductId,
					[action.productId]: {
						request: action.request,
						isFetching: false,
						dataset: action.dataset,
					},
				},
			};

		case ActionType.pruneAll:
			return createState();

		default:
			return state;
	}
}

export function selectDatasetByProductId(state: State, productId: string): DatasetState | null {
	return state.byProductId[productId];
}
